// extracted by mini-css-extract-plugin
export default {"root":"_2FY99N_4","button":"_2oSIBL4M","disabled":"_1lVS-4es"};